import AxiosDefault from "services/AxiosDefault";

export const GetReservationsByPlaceIdAPI = async (data) => {
  const response = await AxiosDefault({
    method: "POST",
    url: `/reservations/list`,
    data: data,
  });
  return response;
};

export const GetReservationsStatisticsAPI = async (placeId) => {
  const response = await AxiosDefault({
    method: "get",
    url: `/reservations/statistics/${placeId}`,
  });
  return response;
};

export const UpdateLicensePlateAPI = async ({ reservationId, ...rest }) => {
  const response = await AxiosDefault({
    method: "put",
    url: `/reservations/updateLicensePlate/${reservationId}`,
    data: rest,
  });
  return response;
};
export const UpdateSpaceNumberAPI = async ({ reservationId, ...rest }) => {
  const response = await AxiosDefault({
    method: "put",
    url: `/reservations/updateSpaceNumber/${reservationId}`,
    data: rest,
  });
  return response;
};

export const GetVehicleCheckLogsAPI = async (params) => {
  const query = new URLSearchParams(params).toString();
  const response = await AxiosDefault({
    method: "get",
    url: `/reservations/vehicle-check-logs?${query}`,
  });
 return response;
};
